import PropTypes from 'prop-types';
import React from 'react';

import { Badge } from '../Badge';
import { formatBadgeDate, formatShortDate, isDataErrorDismissal } from './visitsDue';

const StatusPills = ({ row }) => {
  if (row.dueState === 'booked') {
    return <Badge variant="green">Booked {formatBadgeDate(row.bookedVisit?.date)}</Badge>;
  }
  if (row.dueState === 'held') return <Badge variant="outline">Held</Badge>;
  if (row.dueState === 'dismissed') {
    return (
      <Badge variant="outline">
        {isDataErrorDismissal(row) ? 'Data issue flagged' : 'Dismissed'}
      </Badge>
    );
  }
  if (row.dueState === 'deferred') {
    return <Badge variant="blue">Deferred until {formatShortDate(row.heldUntil)}</Badge>;
  }

  return (
    <>
      <Badge variant={row.dueState === 'overdue' ? 'red' : 'yellow'}>
        {row.daysPastDue} {row.daysPastDue === 1 ? 'day' : 'days'} past due
      </Badge>
      {row.lapsed && <Badge variant="red">Lapsed</Badge>}
    </>
  );
};

StatusPills.propTypes = {
  row: PropTypes.shape({
    dueState: PropTypes.string.isRequired,
    daysPastDue: PropTypes.number.isRequired,
    lapsed: PropTypes.bool.isRequired,
    heldUntil: PropTypes.string,
    bookedVisit: PropTypes.shape({
      date: PropTypes.string,
    }),
  }).isRequired,
};

export default StatusPills;
